import { Box, Container, Flex, SegmentedControl } from "@mantine/core";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import TestSeriesSyllabus from "../../../../packages/ui2/components/TestSeriesSyllabus";
import { get_seo } from "../../seo/seoCommon";
import ScrollTop from "../../../../packages/ui2/components/ScrollTop";
import { GateSyllabusText } from "../../../../packages/ui2/components/GateSyllabus";
import BigLinkButton from "../../../../packages/ui2/components/BigLinkButton";
import { IconArrowLeft } from "@tabler/icons";

const GATESyllabusPage = () => {
    const [value, setValue] = useState("gate");
    const router = useRouter();

    useEffect(() => {
        // onchange visit the appropriate syllabus page
    }, [value]);

    return (
        <Fragment>
            {get_seo("syllabus")}

            {/* add segmented button with gate syllabus and test series syllabus */}
            <Box mt={10}>
                <GateSyllabusText />
            </Box>
            <Container>
                <Flex>
                    <BigLinkButton
                        href={"/syllabus"}
                        title={"Go Back"}
                        description={"Go to syllabus page"}
                        direction={"row-reverse"}
                        icon={<IconArrowLeft />}
                    />
                </Flex>
            </Container>
            <ScrollTop />
        </Fragment>
    );
};

export default GATESyllabusPage;
